import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localTime'
})
export class LocalTimePipe implements PipeTransform {
  public transform(
    dateTime: string, // ISO string
    format: 'time' | 'date' = 'time'
  ): string {
    if (!dateTime) {
      return '';
    }

    const date = new Date(dateTime);

    if (format === 'time') {
      return date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true
      });
    }

    if (format === 'date') {
      return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      });
    }
    return '';
  }
}
